import { Routes } from "@angular/router";
import { MsalGuard } from "@azure/msal-angular";
import { HomeComponent } from "./features/pages/home/home.component";
import { DevelopmentPage } from "./features/pages/development-page/development-page";
import { UserProfileComponent } from "./features/pages/user-profile/user-profile";
import { FaqPage } from "./features/pages/faq-page/faq-page";
import { FeedbackPage } from "./features/pages/feedback-page/feedback-page";
import { DocumentsPage } from "./features/pages/documents-page/documents-page";
import { MobilityPage } from "./features/pages/mobility-page/mobility-page";
import { PortalQuestionnairePage } from "./features/pages/portal-questionnaire-page/portal-questionnaire-page";
import { QuestionnairePage } from "./features/pages/questionnaire-page/questionnaire-page";
import { MobilityRefSearchPage } from "./features/pages/mobility-ref-search-page/mobility-ref-search-page";
import { MobilityRefResultPage } from "./features/pages/mobility-ref-result-page/mobility-ref-result-page";
import { questionnaireLeave } from "./features/pages/questionnaire-page/questionnaire-guard";
import { JobSearchPage } from "./features/pages/job-search-page/job-search-page";
import { JobResultPage } from "./features/pages/job-result-page/job-result-page";
import { VideoSearchPage } from "./features/pages/video-search-page/video-search-page";
import { VideoResultPage } from "./features/pages/video-result-page/video-result-page";
import { JourneySearchPage } from "./features/pages/journey-search-page/journey-search-page";
import { ClarifyProjectPage } from "./features/pages/journey-result-pages/common/clarify-project-page/clarify-project-page";
import { LanguageTestPage } from "./features/pages/journey-result-pages/mature/language-test-page/language-test-page";
import { MobilityRefPage } from "./features/pages/journey-result-pages/mature/mobility-ref-page/mobility-ref-page";
import { HrContactJourneyPage } from "./features/pages/journey-result-pages/common/hr-contact-journey-page/hr-contact-journey-page";
import { OffersPage } from "./features/pages/journey-result-pages/mature/offers-page/offers-page";
import { HrContactPage } from "./features/pages/hr-contact-page/hr-contact-page";
import { JourneyLandingPage } from "./features/pages/journey-landing-page/journey-landing-page";
import { ErrorPage } from "./features/pages/error-page/error-page";
import { errorPageLeave } from "./features/pages/error-page/error-page-guard";

export const routes: Routes = [
  {
    path: "",
    canActivate: [MsalGuard],
    data: { title: "Parent page", breadcrumb: "breadcrumb.home" },
    children: [
      {
        path: "",
        component: HomeComponent,
        data: { title: "Home", breadcrumb: "" },
      },
      {
        path: "development",
        component: DevelopmentPage,
        data: { title: "Développement", breadcrumb: "breadcrumb.development" },
      },
      {
        path: "mobility",
        data: { title: "My mobility", breadcrumb: "breadcrumb.mobility" },
        children: [
          {
            path: "",
            component: MobilityPage,
            data: { title: "My mobility", breadcrumb: "" },
          },
          {
            path: "referents-search",
            component: MobilityRefSearchPage,
            data: {
              title: "Mobility search",
              breadcrumb: "breadcrumb.mobilityRefSearch",
            },
          },
          {
            path: "referents-results",
            component: MobilityRefResultPage,
            data: {
              title: "Mobility search results",
              breadcrumb: "breadcrumb.mobilityRefResults",
            },
          },
          {
            path: "jobs-search",
            component: JobSearchPage,
            data: {
              title: "Our open positions",
              breadcrumb: "breadcrumb.openPositionsSearch",
            },
          },
          {
            path: "jobs-results",
            component: JobResultPage,
            data: {
              title: "Our open positions",
              breadcrumb: "breadcrumb.openPositionsResults",
            },
          },
          {
            path: "videos-search",
            component: VideoSearchPage,
            data: {
              title: "Our jobs",
              breadcrumb: "breadcrumb.jobsSearch",
            },
          },
          {
            path: "videos-results",
            component: VideoResultPage,
            data: {
              title: "Our jobs",
              breadcrumb: "breadcrumb.jobsResults",
            },
          },
        ],
      },
      {
        path: "journey",
        data: {
          title: "My journey",
          breadcrumb: "breadcrumb.personalizedJourney",
        },
        children: [
          {
            path: "",
            component: JourneyLandingPage,
            data: { title: "My journey explained", breadcrumb: "" },
          },
          {
            path: "search",
            component: JourneySearchPage,
            data: { title: "My journey", breadcrumb: "breadcrumb.journeySearch" },
          },
          {
            path: "clarify",
            component: ClarifyProjectPage,
            data: {
              title: "Clarify my project",
              breadcrumb: "breadcrumb.clarifyProject",
            },
          },
          {
            path: "language-test",
            component: LanguageTestPage,
            data: {
              title: "Language Test",
              breadcrumb: "breadcrumb.languageTest",
            },
          },
          {
            path: "mobility-ref",
            component: MobilityRefPage,
            data: {
              title: "Mobility Reference",
              breadcrumb: "breadcrumb.mobilityRef",
            },
          },
          {
            path: "offers",
            component: OffersPage,
            data: {
              title: "Offers",
              breadcrumb: "breadcrumb.offers",
            },
          },
          {
            path: "hr-contact",
            component: HrContactJourneyPage,
            data: {
              title: "HR Contact",
              breadcrumb: "breadcrumb.hrContact",
            },
          },
        ],
      },
      {
        path: "user-profile",
        data: { title: "My profile", breadcrumb: "breadcrumb.profile" },
        children: [
          {
            path: "",
            component: UserProfileComponent,
            data: { title: "My profile", breadcrumb: "" },
          },
          {
            path: "faq",
            component: FaqPage,
            data: { title: "FAQ", breadcrumb: "breadcrumb.faq" },
          },
          {
            path: "feedback",
            component: FeedbackPage,
            data: { title: "Your feedback", breadcrumb: "breadcrumb.feedback" },
          },
          {
            path: "documents",
            component: DocumentsPage,
            data: { title: "Documents", breadcrumb: "breadcrumb.documents" },
          },
          {
            path: "portal-questionnaire",
            data: {
              title: "Questionnaire Portal",
              breadcrumb: "breadcrumb.mobilityQuestionnaire",
            },
            children: [
              {
                path: "",
                component: PortalQuestionnairePage,
                data: {
                  title: "Questionnaire Portal",
                  breadcrumb: "",
                },
              },
              {
                path: "questionnaire",
                component: QuestionnairePage,
                data: {
                  title: "Mobility questionnaire",
                  breadcrumb: "breadcrumb.myQuestionnaire",
                },
                canDeactivate: [questionnaireLeave],
              },
            ],
          },
          {
            path: "hr-contact",
            component: HrContactPage,
            data: {
              title: "HR Contact",
              breadcrumb: "breadcrumb.hrContact",
            },
          },
        ],
      },
    ],
  },
  {
    path: "error",
    canDeactivate: [errorPageLeave],
    data: { title: "Error page" },
    component: ErrorPage
  },
  {
    path: "**",
    redirectTo: "",
  },
];
